var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c("v-data-table", {
        staticStyle: { flex: "1 1 auto" },
        attrs: { headers: _vm.headers, items: _vm.items },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "error", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteSkipValue(props.item)
                              },
                            },
                          },
                          [_vm._v("Delete")]
                        ),
                      ],
                    ],
                    2
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.addSkipValueModal,
            callback: function ($$v) {
              _vm.addSkipValueModal = $$v
            },
            expression: "addSkipValueModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title" },
                [
                  _vm._v("\n        Add Skip Value\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeAddForm.apply(null, arguments)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "addForm",
                  model: {
                    value: _vm.addForm.valid,
                    callback: function ($$v) {
                      _vm.$set(_vm.addForm, "valid", $$v)
                    },
                    expression: "addForm.valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    { attrs: { "pa-2": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Skip Value",
                          rules: _vm.addForm.rules.skipValue,
                        },
                        model: {
                          value: _vm.addForm.values.skipValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm.values, "skipValue", $$v)
                          },
                          expression: "addForm.values.skipValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.addForm.valid,
                          },
                          on: { click: _vm.submitAddForm },
                        },
                        [_vm._v("Add")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.closeAddForm },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }